export default __webpack_public_path__ + "static/media/offer-success.69efdbf3.svg";